<template>
	<div  v-show="bodyIsShow">
		<div  class="bigbodywrap">
			<section id="formwrapSection" class="formwrapSection clearfix bac">
				<div class="formwrap">
					<div id="signUpfrom" class="signUpfrom"  method="post">
						<div style="background: #fff;">
							<div  class="sinformRemind"  >请选择车款或直接输入裸车价格</div>
							<div class="sinform">
	                            <em class="fontColorTit">选择车款</em>
	                            <div @click="settlementBtn(1)" class="sinform-text fontColorTit" :style="{'color':selectColor}" id="insertCar" >请选择车款</div>
	                            <div class="icon-arror-r"></div>
	                        </div>
	                        <div class="sinformBotLine"></div>
			                <div class="sinform">
			                    <em class="fontColorTit">裸车价格</em>
			                    <input type="text" v-model="carPriceShow" class="sinform-text fontColorVal" name="usernane" placeholder="裸车价格" maxlength="8" id="usernane">
			                    <em style="margin-left: 0.2rem;">元</em>
			                </div>
			                <div v-if="showLoadContent">
			                	<div class="sinformBotLine"></div>
				                <div class="sinform">
		                            <em class="fontColorTit" >首付比例</em>
		                            <div @click="settlementBtn(3)" class="sinform-text" id="insertPay" style="color: #333;">{{downPaymentRatio}}%</div>
		                            <div class="icon-arror-r"></div>
		                        </div>
		                        <div class="sinformBotLine"></div>
		                        <div class="sinform">
		                            <em class="fontColorTit">还款年限</em>
		                            <div  @click="settlementBtn(4)" class="sinform-text" id="insertYear" style="color: #333;">{{loanTerm/12}}年</div>
		                            <div class="icon-arror-r"></div>
		                        </div>
			                </div>
		                </div>
		                <div class="sinform" style="margin-top: 0.32rem;display: flex;justify-content: space-evenly;">
		                    <em class="fontColorTit">手机号  </em>
		                    <input type="tel" autocomplete="off" class="sinform-text-tel fontColorVal" name="Phone" placeholder="请输入手机号码" maxlength="11" id="Phone">
		                </div>
		               
		                <div class="sub-wrap" >
                            <div class="singsubmit tobtn gradient" @click="settlementBtn(2)" data-track="carfestivalDetailToutiao-1-signUp" id="index-submit" ut-data-click ut-data-convertid="42715" ut-data-eventtype="FormSubmit">
                                <button class="buttonSubmit tobtn gradient" id="startCompute">开始计算</button>
                            </div>
		                </div>
						<div style="margin-bottom:1em;" class="addxyroom">*计算结果将会以短信形式发送到您的手机</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import { Toast } from 'mint-ui';
import MsgBus from "../../../assets/bus/bus.js"
export default {
	name: 'fullSection',
	data:function() {
		return {
			bodyIsShow:false,
			pageStatus:false,
			selectColor:'#959595',
			state:'0',
			objData:{},
			showLoadContent:false,
			brandId:'',
			brandName:'',
			styleId:'',
			styleName:'',
			styleSeriesId:'',
			styleSeriesName:'',
			buyType:0,
			phone:'',
			totalPrice:'裸车价格',
			carPrice:null,
			necPrice:null,
			vehiclePurchaseTaxes:null,
			vehicleVesselTax:420,
			displacement:1,
			sali:950,
			seatCountFlag:0,
			regPrice:500,
			downPayment:null,
			downPaymentRatio:30,
			payMonthly:null,
			loanTerm:36,
			loanLimit:null,
			interestRate:0.0525,
			interest:null,
			sendFlag:1,
			carAllName:'',
			id:'',
			carPriceShow:''
		}
	},
	watch:{
		carPriceShow:function(val){
			var self = this;
			this.carPriceShow = val;
			this.carPrice=self.toNum(this.carPriceShow);
//			console.log(this.carPrices);
//			console.log(self.buyTypes);
		}
	},
	mounted:function(){
		var self = this;
		getCommonJsIns.initCSSNEW();
		getCommonJsIns.initSingleCSSNEW({
			cssURL: "/css/mapply/calculator/index.css?v=123"
		});
		
		//确保重要依赖的js加载完成
		getCommonJsIns.initJSNEW(this.webReady);
	},
	
	methods:{

		initFull:function(showLoads,showResult,buyTypes){
				var self =this;
				self.showLoadContent=showLoads;
				self.pageStatus=showResult;
				self.buyType=buyTypes;
		},
		webReady:function(){
			var self =this;
			self.bodyIsShow=true;
			
			MsgBus.$on('msgFull', function(option){
				self.objData=option;
				$("#insertCar").text(self.objData.name+'-'+self.objData.styleName+'-'+self.objData.brandname);
				self.selectColor="#333333";
				self.showLoadContent=self.objData.showLoadContent;
				self.brandId=option.brandid;
				self.brandName=option.brandname;
				self.styleId=option.styleid;
				self.styleName=option.styleName;
				self.styleSeriesId=option.styleSeriesid;
				self.styleSeriesName=option.name;
				self.carAllName=self.objData.name+'-'+self.objData.styleName+'-'+self.objData.brandname;
				self.carPrice=(option.referPrice*10000).toFixed(2);
				self.carPriceShow=self.toMoney(self.carPrice);
				console.log(self.carPrice)
			});
			MsgBus.$on('msgLoadPay', function(option){
				
				self.downPaymentRatio=option;
			});
			MsgBus.$on('msgLoadYear', function(option){
				
				self.loanTerm=option;
			});
			
		},
		
        settlementBtn:function(type){
        	var self=this;
        	self.state=type;
        	if(type==2){
        		self.pageStatus=true;
				self.submitSignup();
				
        	}else{
        		var obj={
	        		state:self.state,
	        		pageStatus:self.pageStatus,
	        		showLoadinfo:self.showLoadContent,
	        		
	        	};
				this.$emit('childByValueFull', obj);
        	}
        	
			
        },
        pmt:function(rate,term,financeAmount){
		//计算月供
		    var v = (1+(rate/12)); 
		
		    var t = (-(term/12)*12); 
		
		    var result=(financeAmount*(rate/12))/(1-Math.pow(v,t));
		
		    return result;
		
		},
		subApply:function(data){
			$("#startCompute").attr("disabled", "disabled");
			var self = this;
			self.pmt();
			self.ajaxSubmit.ajax({
//				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.calcultorSend,
				type:"post",
				data:data,
//				contentType: 'application/json;charset=UTF-8',
				success:function(data){
					if(data.responseHeader.status == 200){
						$("#startCompute").removeAttr("disabled");
						self.id=data.response.result.id;
						var ajaxDataObj={};
						ajaxDataObj=data.response.result;
						ajaxDataObj.carAllName=self.carAllName;
						var obj={
			        		state:self.state,
			        		pageStatus:self.pageStatus,
			        		showLoadinfo:self.showLoadContent,
			        		brandName:self.brandName,
			        		styleName:self.styleName,
			        		styleSeriesName:self.styleSeriesName,
			        		id:self.id,
			        	};
						if(self.checkData()){
							self.$emit('childByValueFull', obj);
						}
//						this.$emit('childByValueFull', ajaxDataObj);
						MsgBus.$emit('msgShow', ajaxDataObj);
						
					}
					
				},
				error:function(){
					$("#tikect-sub").removeAttr("disabled");
					$("#signUpButton").removeAttr("disabled");
					Toast({
	                  message: "系统忙，请稍后",
	                  position: 'middle',
	                  duration: 2000
	                });
				}
			});
		},
		//千位分隔符
		// 将金额类型转为数字类型
		toNum:function (str) {
			return str.replace(/\,|\￥/g, "");
		},
		//千位分隔符
		// 保留两位小数（四舍五入）
		toMoney:function(num) {
			var self=this;
			num = parseFloat(num).toString().split(".");
			num[0] = num[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");
			return num.join(".");
		},
		calculationFormula:function(){
			var self = this;
			//          裸车价取整
			self.carPrice =Math.ceil(parseFloat(self.carPrice));
			self.carPriceShow=self.toMoney(self.carPrice);
			//首付比例乘以100
//			var downPayme=self.downPaymentRatio*100;
            //全款计算
			//购置税
			self.vehiclePurchaseTaxes=Math.ceil(self.carPrice/1.17*0.1);
			//较强险  六座以下
			self.sali=Math.ceil(self.sali);
			// 车船税 1.0-1.6L的税费
			self.vehicleVesselTax=Math.ceil(self.vehicleVesselTax);
			//上牌费用
			self.regPrice=Math.ceil(self.regPrice);
			//六座以下
			self.seatCountFlag=self.seatCountFlag;
			//1.0-1.6L
			self.displacement=self.displacement;
			
			//必要花费
			self.necPrice=self.vehiclePurchaseTaxes+self.sali+self.vehicleVesselTax+self.regPrice;
			//贷款计算
			//	首付比例(乘以100)
			self.downPaymentRatio=self.downPaymentRatio;
//			self.downPaymentRatio*100;传给后台的值
            //贷款时长 单位:月
			self.loanTerm=self.loanTerm;
			
			if(self.loanTerm==12){
				self.interestRate=0.0485;
			}else if(self.loanTerm==24){
				self.interestRate=0.0525;
			}else if(self.loanTerm==36){
				self.interestRate=0.0525;
			}else if(self.loanTerm==48){
				self.interestRate=0.0525;
			}else if(self.loanTerm==60){
				self.interestRate=0.0525;
			}
			//利率
			self.interestRate=self.interestRate;
			//贷款额度
			self.loanLimit=Math.ceil(self.carPrice-(self.carPrice*(self.downPaymentRatio/100)));
			//月付
			//按照此基准利率：1年期4.85%；2年期5.25%；3年期5.25%；4年期5.25%；5年期5.25%
			//使用方法：
			//var vv = pmt(0.1,30,100000);
			self.payMonthly=Math.ceil(self.pmt(self.interestRate,self.loanTerm,self.loanLimit));
			//利息
			self.interest=Math.ceil(self.payMonthly*self.loanTerm-self.loanLimit);
			//首付金额
			self.downPayment=Math.ceil(self.carPrice*self.downPaymentRatio/100)+self.vehiclePurchaseTaxes+self.sali+self.vehicleVesselTax+self.regPrice;
			
			
			if(self.buyType==0){
				//全款总价
				self.totalPrice=self.carPrice+self.vehiclePurchaseTaxes+self.sali+self.vehicleVesselTax+self.regPrice;
			}else{
				//全款总价
				self.totalPrice=self.downPayment+self.interest+self.loanLimit;
			}
		},
		checkData:function(){
			if(!webCommonUtil.commonFun.isPhone($("#Phone").val())){
				Toast({
                  message: "请填写11位手机号码",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else if(this.carPriceShow== null ||this.carPriceShow== ''||this.carPriceShow== undefined){
				Toast({
                  message: "请填写裸车价格",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else{
				return true;
			};
		},
     	submitSignup:function(){
			var self = this;
			this.phone=$("#Phone").val();
						
//			alert(this.phone)
			localStorage.setItem('ursePhone',self.phone);
//			alert(localStorage.getItem('ursePhone'));
			if(self.checkData()){
			self.calculationFormula();
			debugger
			var data = {
					"phone":self.phone,	//手机号
					"brandId":self.brandId,	//Integer	品牌id
					"brandName":self.brandName,//品牌名称
					"styleId":self.styleId,	//Integer	款式id
					"styleName":self.styleName,	//	款式名称
					"styleSeriesId":self.styleSeriesId,//Integer	款式系列id
					"styleSeriesName":self.styleSeriesName,	//	款式系列名称
					"buyType":self.buyType,	//Integer	0:全款, 1:贷款
					"totalPrice":self.totalPrice,	//BigDecimal	总价
					"carPrice":self.carPrice,	//BigDecimal	裸车价
					"necPrice":self.necPrice,	//BigDecimal	必要的花费
					"vehiclePurchaseTaxes":self.vehiclePurchaseTaxes,	//BigDecimal	车辆购置税
					"vehicleVesselTax":self.vehicleVesselTax,	//BigDecimal	车船使用税
					"displacement":self.displacement,	//Integer	排量 0:1.0L(含)以下, 1:1.0-1.6(含)以下, 2:1.6-2.0(含)以下, 3:2.0-2.5(含)以下, 4:2.5-3.0(含)以下，5:3.0-4.0(含)以下, 6:4.0L
					"sali":self.sali,	//BigDecimal	交强险金额
					"seatCountFlag":self.seatCountFlag,	//Integer	座位数量 0:6座以下、1:6座以上
					"regPrice":self.regPrice,	//BigDecimal	上牌费
					"downPayment":self.downPayment,	//BigDecimal	首付金额
					"downPaymentRatio":	self.downPaymentRatio,//Integer	首付比例(乘以100)
					"payMonthly":self.payMonthly,	//BigDecimal	月付
					"loanTerm":self.loanTerm,	//Integer	贷款时长 单位:月
					"loanLimit":self.loanLimit,	//BigDecimal	贷款额度
					"interestRate":self.interestRate,	//Double	利率
					"interest":self.interest,	//BigDecimal	利息
					"sendFlag":self.sendFlag,	//Integer	是否发送短信0：发送，1：不发送
			};
			self.subApply(data);
			}
		},
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/calculator/fullSection/fullSection.vue